import { html } from 'lit';
const Appearance =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M12 3.75a8.25 8.25 0 1 0 0 16.5A2.25 2.25 0 0 0 14.25 18v-.659c0-.314 0-.556.034-.771a2.75 2.75 0 0 1 2.286-2.286c.215-.034.457-.034.771-.034H18A2.25 2.25 0 0 0 20.25 12 8.25 8.25 0 0 0 12 3.75M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75A3.75 3.75 0 0 1 18 15.75h-.6c-.4 0-.513.002-.595.015a1.25 1.25 0 0 0-1.04 1.04c-.013.082-.015.195-.015.595v.6A3.75 3.75 0 0 1 12 21.75c-5.385 0-9.75-4.365-9.75-9.75m7-4.5a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m5 1a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m-8 3a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0" clip-rule="evenodd"/>
  </svg>
`;
export default Appearance;
